module.exports = __webpack_public_path__ + "img/login-logo.fa3572bf.png";